import {Injectable} from "@angular/core";
import {UnsubscribeBaseServiceModel} from "../client/UnsubscribeBaseService.model";
import {AppData} from "../AppData";
import { HttpClient } from "@angular/common/http";
import {CompoApp} from "../CompoApp";
import {Observable} from "rxjs/internal/Observable";
import {UrlBuilder} from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import {take} from "rxjs/operators";
import {CostTypeDtoModel} from "../../models/designations-and-icon/cost-type-dto.model";

@Injectable()
export class CostTypeRequestService extends UnsubscribeBaseServiceModel {

  //region FIELDS
  private data: AppData;

  //endregion

  //region CONSTRUCTOR
  constructor(private http: HttpClient,
              private app: CompoApp) {
    super();
    this.data = app.data;
  }
  //endregion

  //region REQUEST METHODS
  createCostType(model: CostTypeDtoModel): Observable<CostTypeDtoModel> {
    const url = new UrlBuilder(Constants.URLS.invoiceType.save)
      .param('accessMode', this.data.getAccessMode())
      .param('lang', this.data.getLang())
      .build();

    return this.http.post<CostTypeDtoModel>(url, model).pipe(take(1));
  }

  updateCostType(model: CostTypeDtoModel) : Observable<CostTypeDtoModel> {
    const url = new UrlBuilder(Constants.URLS.invoiceType.update)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<CostTypeDtoModel>(url, model).pipe(take(1));
  }

  deleteCostType(id: number) : Observable<void> {
    const url = new UrlBuilder(Constants.URLS.invoiceType.delete)
      .param('id', id)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<void>(url, null).pipe(take(1));
  }

  //endregion
}
